import { Icon } from './icons/Icon.jsx'
import styles from './ChatHeader.module.css'

/** Chat header (§5.4): title, sub-line and optional actions. */
export function ChatHeader({ title, subtitle, actions }) {
  return (
    <header className={styles.header}>
      <div className={styles.titles}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <span className={styles.sub}>{subtitle}</span> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  )
}

export function ShareButton(props) {
  return (
    <button type="button" className="btn btn-ghost" {...props}>
      <Icon name="share" size={15} strokeWidth={1.6} />
      Share
    </button>
  )
}

export function MoreButton(props) {
  return (
    <button type="button" className={`btn btn-ghost ${styles.more}`} aria-label="More options" {...props}>
      <Icon name="dots" size={16} />
    </button>
  )
}
